import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'app/frontend/lib/shared/util/user';
import { AnnouncementService } from './announcement.service';

@Component({
    selector: 'announcement',
    templateUrl: './announcement.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule]
})
export class AnnouncementComponent implements OnInit {

    @Input() header: string;
    @Input() body: string;
    @Input() cta: string;
    
    show: boolean;
    
    constructor(
        private userService: UserService,
        private announcementService: AnnouncementService
    ) { }

    async ngOnInit() {
        const user = await this.userService.get();
        this.show = this.announcementService.showForUserFunction(user);
    }
    
}